// @flow
import React from 'react';
import moment from 'moment-timezone';

import IconFullScreen from 'app/common/icons/IconFullScreen';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import useGenerateFileRequests from 'app/components/common/reports/history/useGenerateFileRequests';
import { GenerateFile } from 'app/common/ui-components/progress-indicator';
import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';
import HistoryLink, { reportTypes } from 'app/components/common/reports/history/HistoryLink';
import { formats } from 'app/common/api/requests/reports/generate_file';

import styles from './HeaderBar.scss';


type Props = {
  onFullscreen: (e: SyntheticEvent<HTMLElement>) => void,
  reportId: number,
}

const HeaderBar = ({ onFullscreen, reportId }: Props) => {
  const reportFileName = `${reportTypes.REPORT_FINANCES_CAFETERIA_CASH}_${moment().format('YYYYMMDD_HHmmss')}.zip`;
  const generateFileRequests = useGenerateFileRequests(reportId, reportFileName, formats.ZIP);

  return (
    <div className={styles.root}>
      <GenerateFile
        className={styles.download}
        labelClassName={styles.downloadLabel}
        label="Скачать как"
        generateAndDownloadPrompt="Сгенерировать и скачать в формате «документ Excel» (zip архив)"
        downloadPrompt="Скачать в формате «документ Excel» (zip архив)"
        {...generateFileRequests}
      >
        <PlainIcon
          width={20}
          height="auto"
          type={iconTypes.EXCEL}
        />
      </GenerateFile>

      <HistoryLink
        className={styles.historyButton}
        reportType={reportTypes.REPORT_FINANCES_BY_SELL_TYPE}
      />

      <PlainButtonAsLink
        id="fullscreen"
        ariaLabel="Открыть в полном окне"
        onClick={onFullscreen}
      >
        <IconFullScreen className={styles.fullscreenIcon} />
      </PlainButtonAsLink>
    </div>
  );
};

export default HeaderBar;
